import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from "react";
import { SectionHeader } from "../SectionHeader";
import FormOption from "./../../FormOption";
import { Row } from "./../../Grid";
import * as S from "./styles";
export function DeliveryOptions(_ref) {
  var _ref$options = _ref.options,
      e = _ref$options === void 0 ? [] : _ref$options,
      t = _ref.selectedOption,
      _ref$showHeader = _ref.showHeader,
      a = _ref$showHeader === void 0 ? !0 : _ref$showHeader,
      _ref$standardOnly = _ref.standardOnly,
      n = _ref$standardOnly === void 0 ? !0 : _ref$standardOnly,
      i = _ref.register,
      r = _ref.setValue,
      l = _ref.watch,
      o = _ref.onChange;
  var p;
  var c = l && l("shippingType");
  p = n ? [e.find(function (e) {
    return "standard" === e.name;
  })] : e;

  var s = p.length,
      m = function m() {
    return e.find(function (e) {
      return e.value === t;
    }) ? t : p[0].value;
  },
      _useState = useState(m),
      _useState2 = _slicedToArray(_useState, 2),
      d = _useState2[0],
      u = _useState2[1],
      _useState3 = useState(m),
      _useState4 = _slicedToArray(_useState3, 2),
      f = _useState4[0],
      v = _useState4[1],
      y = function y(e) {
    var t = function (e) {
      return p.find(function (t) {
        return t.id === e;
      });
    }(e),
        a = null == t ? void 0 : t.value;

    u(a), function (e) {
      r && r("shippingType", e);
    }(a), v(a), o && o(t);
  };

  return useEffect(function () {
    var e = p.find(function (e) {
      return e.name === c;
    });
    e && y(e.id);
  }, [c]), React.createElement(React.Fragment, null, a && React.createElement(SectionHeader, {
    title: "Delivery Options"
  }), React.createElement("input", {
    type: "hidden",
    id: "shippingType",
    name: "shippingType",
    value: f,
    ref: i && i()
  }), React.createElement(Row, null, React.createElement(S.OptionsWrapper, null, p.map(function (e, t) {
    return React.createElement(FormOption, {
      key: e.name,
      id: e.id,
      name: e.name,
      value: e.value,
      label: {
        label: e.title,
        subLabel: (a = e.price, a <= 0 ? "Free" : "$".concat(a)),
        labelDescription: e.estimate
      },
      checked: d === e.value,
      onChange: y,
      displaySeparator: t !== s - 1
    });
    var a;
  }))));
}
export default DeliveryOptions;